import {
  styled,
  Grid as GridBase,
  Paper,
  Typography,
  TextField,
  Button,
} from "@mui/material";

export const AdminSection = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
  borderRadius: 16,
  padding: "0 0 24px",
  margin: "16px 0 0 0",
  boxShadow: "0 8px 32px rgba(81, 58, 151, 0.1)",
  border: `1px solid ${theme.palette.divider}`,
  backdropFilter: "blur(10px)",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 4,
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
  marginBottom: 8,
  display: "flex",
  alignItems: "center",
  gap: 8,
  "&::before": {
    content: '"⚙️"',
    fontSize: "1.2em",
  },
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.9rem",
  marginBottom: 24,
  fontStyle: "italic",
}));

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: 0;
    gap: 16px;
  }
`;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledFieldsContainer = styled(GridContainer)`
  &.MuiGrid-container {
    justify-content: center;
  }
`;

export const ButtonsContainer = styled(GridContainer)`
  &.MuiGrid-container {
    justify-content: center;
    margin-top: 16px;
    gap: 12px;
  }
`;

export const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: 120,
  height: 40,
  borderRadius: 8,
  fontWeight: 600,
  textTransform: "none",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  gap: 8,
  "&.reset-button": {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.divider}`,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
  },
  "&.apply-button": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(81, 58, 151, 0.3)",
    },
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(81, 58, 151, 0.1)",
    },
    "&.Mui-focused": {
      backgroundColor: theme.palette.background.paper,
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(81, 58, 151, 0.15)",
    },
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.divider,
    borderWidth: 2,
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.light,
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
}));
